import { COUNTRIES, type CountryCode, type EntityType } from '@keel/core';

/** Entity colour swatches (stored on the entity; match the light chart tokens). */
export const ENTITY_COLOURS = ['#0b6b6b', '#b07206', '#2f6fbf', '#7a52b3', '#c2456b', '#3c8f4f'] as const;

/** Rates set by the kind of entity; everyone else gets the server's country default. */
const DEFAULT_RATE: Partial<Record<EntityType, number>> = { smsf: 0.15, company: 0.25 };

export const DEFAULT_ENTITY_NAME: Record<EntityType, string> = {
  individual: 'Personal', household: 'Our household', smsf: 'Our SMSF', trust: 'Family trust', company: 'My company',
  partnership: 'Partnership', sole_trader: 'My business', club: 'Our club',
};

/** `entities.create` payload with country-derived currency/locale/FY and an entity-appropriate tax profile. */
export const entityPayload = (type: EntityType, country: CountryCode, name: string, colourIndex = 0) => {
  const cfg = COUNTRIES[country] ?? COUNTRIES.AU;
  return {
    name: name.trim() || DEFAULT_ENTITY_NAME[type],
    type,
    country: cfg.country,
    baseCurrency: cfg.currency,
    locale: cfg.locale,
    fyStartMonth: cfg.fyStartMonth,
    fyStartDay: cfg.fyStartDay,
    color: ENTITY_COLOURS[colourIndex % ENTITY_COLOURS.length],
    taxProfile: {
      entityType: type,
      // personal rates default on the server by country (GB 20 %, AU 30 % + Medicare…); only entity-type rates are sent
      ...(DEFAULT_RATE[type] !== undefined ? { marginalRate: DEFAULT_RATE[type] } : {}),
      gstRegistered: false,
      smsf: type === 'smsf' ? { fundName: name.trim() || DEFAULT_ENTITY_NAME.smsf, pensionPhaseProportion: 0, investmentStrategyTargets: [] } : null,
    },
    seedDefaults: true,
  };
};

/** Country-derived fields for `entities.update` when the country changes. */
export const countryPatch = (country: CountryCode) => {
  const cfg = COUNTRIES[country] ?? COUNTRIES.AU;
  return { country: cfg.country, baseCurrency: cfg.currency, locale: cfg.locale, fyStartMonth: cfg.fyStartMonth, fyStartDay: cfg.fyStartDay };
};
